var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style=stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8.396C11.9529 8.396 11.1041 9.24479 11.1041 10.2918C11.1041 11.3389 11.9529 12.1877 13 12.1877C14.047 12.1877 14.8958 11.3389 14.8958 10.2918C14.8958 9.24479 14.047 8.396 13 8.396ZM9.47913 10.2918C9.47913 8.34732 11.0555 6.771 13 6.771C14.9444 6.771 16.5208 8.34732 16.5208 10.2918C16.5208 12.2363 14.9444 13.8127 13 13.8127C11.0555 13.8127 9.47913 12.2363 9.47913 10.2918Z",
    fill: "#048E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2047 9.38625C19.2899 0.849825 6.71987 0.840815 4.79514 9.37582C4.255 11.7837 4.91391 14.0484 6.11627 16.1105C7.32342 18.1809 9.04088 19.9814 10.5115 21.4228C10.5118 21.4231 10.5122 21.4234 10.5125 21.4238L10.8205 21.7236C10.8213 21.7244 10.822 21.7251 10.8228 21.7258C11.8655 22.7245 12.5077 23.0212 13.0134 23.0154C13.5245 23.0095 14.1744 22.6924 15.2247 21.6697L15.2262 21.6683C16.7101 20.2305 18.5021 18.4083 19.7771 16.2937C21.047 14.1874 21.7606 11.8636 21.2047 9.38625ZM9.69159 22.8924L9.63221 22.8352L9.63119 22.8343C9.5471 22.7525 9.46166 22.6692 9.37508 22.5843C7.88924 21.1281 6.03655 19.2 4.71247 16.929C3.38338 14.6496 2.54995 11.96 3.20963 9.01971C5.5156 -1.20816 20.4963 -1.19617 22.7903 9.03058C23.4692 12.0566 22.5669 14.8136 21.1686 17.1327C19.7757 19.4432 17.8476 21.3909 16.3574 22.8348C15.2702 23.8934 14.2197 24.6266 13.032 24.6403C11.839 24.654 10.7841 23.9395 9.69623 22.897L9.69159 22.8924Z",
    fill: "#048E7D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvgrepoCom1);
export default __webpack_public_path__ + "static/media/location-svgrepo-com 1.5acebd752738939c2545600bbc1f6a33.svg";
export { ForwardRef as ReactComponent };